import * as React from 'react'
import { useEffect } from 'react'
import styled from 'styled-components'
import { useWalletClient } from 'wagmi'
import { useMount } from 'ahooks'
import { useToast } from '@pancakeswap/uikit'
import { cedeApi } from 'hooks/cede/CedeApi'
import { filterPrecision, filterThousands, verifyValidNumber } from 'utils/tools'
import { renderSendWidget } from '@cedelabs/widgets-universal'
import FooterNew from '../../components/FooterNew'
import { Button, Input } from '../../componentsNew'
import { IconGlobalCopy, IconSelectArrow } from '../../assets/icons/IconGroup'
import CedeSelect from '../../componentsNew/_global/CedeSelect'

const Wrapper = styled.div`
  @media not screen and (max-width: 1280px) {
    .chrome {
      height: 80px;
      border-bottom: 1px solid rgba(255, 201, 177, 0.12);

      img {
        width: 60px;
        height: 60px;
      }

      b {
        margin: 0 16px;
        font-size: 28px;
        font-weight: 600;
      }

      p {
        margin: 0 48px 0 24px;
        font-size: 18px;
        font-weight: 500;
      }

      button {
        width: max-content;
      }
    }

    .kernel {
      padding: 84px 0;
      /* min-height: calc(100vh - 64px); */
      min-height: 680px;
    }

    #cede-widget {
      margin: 0 auto;
      width: min-content;
    }

    .global-box {
      margin: 0 auto;
      width: 508px;
      border-radius: 24px;
      background: var(--agniBG, rgba(47, 40, 40, 0.5));
    }

    .box-title {
      position: relative;
      margin-bottom: 16px;
      padding: 0 18px;

      .cede {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        /* border: 2px solid #ec5f4c; */
        border: 2px solid rgba(236, 95, 76, 0.4);
        border-radius: 10px;
        overflow: hidden;
      }

      h4 {
        height: 84px;
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        line-height: 84px;
        color: #fff;
      }
    }

    .box-internal {
      padding: 12px 22px 32px 22px;
    }

    .select {
      .label {
        position: absolute;
        top: -10px;
        left: 22px;
        padding: 0 4px;
        background: rgba(25, 20, 20, 1);
        color: #fff;
        font-size: 14px;
      }

      .handle {
        img {
          padding: 1px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 1px solid rgba(255, 255, 255, 0.2);
          overflow: hidden;
        }

        p {
          margin-left: 8px;
          color: #fff;
        }
      }
    }

    .more-select {
      margin: 28px 0 8px 0;
      gap: 8px;

      > div {
        flex: 1;
      }
    }

    .balance {
      margin-bottom: 28px;
      padding-left: 12px;
      color: rgba(255, 255, 255, 0.45);
      font-size: 14px;
    }

    .address {
      padding: 0 16px;
      height: 40px;
      border-radius: 40px;
      border: 1px solid rgba(236, 95, 76, 0.4);

      p {
        font-size: 16px;
        font-weight: 500;
      }

      svg {
        fill: #fff;
      }
    }

    .input-box {
      position: relative;

      .label {
        position: absolute;
        top: -10px;
        left: 22px;
        padding: 0 4px;
        background: rgba(25, 20, 20, 1);
        color: #fff;
        font-size: 14px;
      }

      .input {
        flex: 1;

        label {
          padding: 0 16px;
          height: 40px;
          background: transparent;
          border-radius: 40px;
          border: 1px solid rgba(236, 95, 76, 0.4);
        }

        input {
          font-size: 16px;
          font-weight: 500;
          line-height: 40px;

          &::placeholder {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.45);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }

    .more-input {
      margin: 28px 0 8px 0;
      gap: 8px;

      > div {
        flex: 1;
      }

      .input-only {
        input {
          width: 140px !important;
        }
      }

      button {
        padding: 0 10px;
        width: max-content;
        min-width: auto;
        height: 24px;
        border-radius: 4px;

        span {
          line-height: 24px;
          font-size: 12px;
        }
      }
    }

    .minimum {
      margin-bottom: 88px;
      padding-left: 12px;
      color: rgba(255, 255, 255, 0.45);
      font-size: 14px;
    }

    .send {
      height: 46px;

      span {
        font-size: 18px;
      }
    }
  }
  @media screen and (max-width: 1280px) {
    .chrome {
      padding: 24px 0;
      flex-wrap: wrap;
      width: 100vw;
      border-bottom: 1px solid rgba(255, 201, 177, 0.12);

      img {
        width: 42px;
        height: 42px;
      }

      b {
        margin: 0 10px;
        font-size: 22px;
        font-weight: 600;
      }

      p {
        margin: 12px 0 24px 0;
        padding: 0 24px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
      }

      button {
        width: max-content;
      }
    }

    .kernel {
      padding: 84px 0;
      min-height: 680px;
    }

    #cede-widget {
      margin: 0 auto;
      width: min-content;
    }
  }
`

const DesktopsSelect = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border-radius: 12px;
  background: #292929;
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.16);
  @media not screen and (max-width: 1280px) {
    li {
      img {
        padding: 1px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, 0.2);
        overflow: hidden;
      }

      p {
        margin-left: 8px;
        color: #fff;
        font-weight: 500;
      }
    }
  }
  @media screen and (max-width: 1280px) {
  }
`

// type IExchangeType = {
//   name: string
//   id: string
//   logo: string
// }

// type ITokenType = {
//   id: string
//   name: string
//   logo: string
//   balance: string
//   price: string
// }

// type IChainType = {
//   name: string
//   id: string
//   chainId: number
//   logo: string
//   minAmount: string
// }

const rootSelector = '#cede-widget'

const IndexPage = () => {
  const { toastSuccess, toastError } = useToast()
  const { data: walletClient } = useWalletClient()

  // 是否安装插件
  const [install, setInstall] = React.useState<boolean>(false)

  const loadInstall = React.useCallback(async () => {
    const checkInstall = await cedeApi.checkInstall()
    // const url = cedeApi.url()
    setInstall(checkInstall)
  }, [])

  useMount(() => {
    loadInstall()
  })

  useEffect(() => {
    // loadInstall()
    const theme = {
      primaryColor: '#181414',
      borderColor: '#6C3423',
      logoBorderColor: '#FFC9B1',
      accentColor: '#FFC9B1',
    }
    let config
    if (walletClient) {
      config = {
        tokenSymbol: 'MNT',
        network: 'mantle',
        address: walletClient?.account.address,
      }
    }

    renderSendWidget(rootSelector, {
      theme,
      config,
    })
  }, [walletClient])

  // // 初始化数据
  // const [unlock, setUnlock] = React.useState<boolean>(false)
  // const [exchange, setExchange] = React.useState<IExchangeType>()
  // const [exchangeList, setExchangeList] = React.useState<IExchangeType[]>([])
  // const [token, setToken] = React.useState<ITokenType>()
  // const [tokenList, setTokenList] = React.useState<ITokenType[]>([])
  // const [chain, setChain] = React.useState<IChainType>()
  // const [chainList, setChainList] = React.useState<IChainType[]>([])

  // const loadExchangeData = React.useCallback(async () => {
  //   // console.log('切换1')
  //   const exchanges = await cedeApi.getExchanges()
  //   // console.log('exchanges', exchanges)
  //   setExchangeList(exchanges)
  //   setExchange(exchanges[0])
  // }, [])

  // const unlockSubmit = React.useCallback(
  //   async (first = false) => {
  //     try {
  //       await cedeApi.unlock(first)
  //       setUnlock(true)
  //       await loadExchangeData()
  //     } catch (error) {
  //       setUnlock(false)
  //     }
  //   },
  //   [loadExchangeData],
  // )

  // useMount(() => {
  //   unlockSubmit(true)
  // })

  // // 三级联动
  // const loadTokenData = React.useCallback(async () => {
  //   if (!exchange) return
  //   // console.log('切换2', exchange.id)
  //   const tokens = await cedeApi.getTokens(exchange.id)
  //   // console.log('tokens', tokens)
  //   setTokenList(tokens)
  //   setToken(tokens[0])
  // }, [exchange])

  // React.useEffect(() => {
  //   loadTokenData()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [exchange])

  // const loadChainData = React.useCallback(async () => {
  //   if (!exchange || !token) return
  //   // console.log('切换3', exchange.id, token.id)
  //   const chains = await cedeApi.getChains(exchange.id, token.id)
  //   // console.log('chains', chains)
  //   setChainList(chains)
  //   setChain(chains[0])
  // }, [exchange, token])

  // React.useEffect(() => {
  //   loadChainData()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [exchange, token])

  // const [input2, setInput2] = React.useState<string>('')

  // const filterPrice = React.useMemo(() => {
  //   if (!token) return '0'
  //   return parseFloat(input2 || '0') * parseFloat(token.price)
  // }, [input2, token])

  // const [loading, setLoading] = React.useState<boolean>(false)

  // const handleSubmit = React.useCallback(async () => {
  //   if (!exchange || !token || !chain || !input2 || !walletClient) return
  //   setLoading(true)
  //   try {
  //     await cedeApi.withdraw(exchange.id, token.id, chain.id, input2, walletClient.account.address)
  //     await loadExchangeData()
  //     toastSuccess('Success', 'Your operation was successful')
  //     setInput2('')
  //     setLoading(false)
  //   } catch (error: any) {
  //     toastError('Error', error.message)
  //     setLoading(false)
  //   }
  // }, [chain, exchange, input2, toastError, toastSuccess, token, walletClient, loadExchangeData])

  return (
    <Wrapper>
      {!install && (
        <div className="chrome row-center">
          <img className="cede" src="/newImages/bridge/cede.png" alt="icon" />
          <b>&</b>
          <img className="cede" src="/newImages/bridge/chrome.svg" alt="icon" />
          <p>Please install the chrome plug-in to use it</p>
          <Button
            type="second"
            onClick={() => {
              window.open(
                'https://chromewebstore.google.com/detail/cedestore/dcfphbfmjohnlcpelbhfbjolhmmlcbhd',
                '_blank',
              )
            }}
          >
            Jump to Chrome Store
          </Button>
        </div>
      )}
      <div className="kernel">
        <div id="cede-widget" />
      </div>

      {/* <div className="kernel">
        <div className="global-box">
          <div className="box-title">
            <img className="cede" src="/newImages/bridge/cede.png" alt="icon" />
            <h4>Send</h4>
          </div>
          <div className="box-internal">
            <CedeSelect
              follow
              disabled={!install || !unlock}
              placeholder="Please select"
              overlay={
                exchange ? (
                  <div className="select">
                    <p className="label">From</p>
                    <div className="handle row-between">
                      <div className="coin row-start">
                        <img src={exchange.logo} alt="icon" />
                        <p>{exchange.name}</p>
                      </div>
                      <IconSelectArrow />
                    </div>
                  </div>
                ) : null
              }
            >
              <DesktopsSelect>
                <ul>
                  {exchangeList.map((ele) => (
                    <li
                      className="row-start"
                      key={ele.id}
                      onClick={() => {
                        setExchange(ele)
                        setToken(undefined)
                        setTokenList([])
                        setChain(undefined)
                        setChainList([])
                        setInput2('')
                      }}
                      aria-hidden
                    >
                      <img src={ele.logo} alt="icon" />
                      <p>{ele.name}</p>
                    </li>
                  ))}
                </ul>
              </DesktopsSelect>
            </CedeSelect>
            <div className="more-select row-between">
              <CedeSelect
                follow
                disabled={!exchange || !token}
                placeholder="Please select"
                overlay={
                  token ? (
                    <div className="select">
                      <p className="label">Currency</p>
                      <div className="handle row-between">
                        <div className="coin row-start">
                          <img src={token.logo} alt="icon" />
                          <p>{token.name}</p>
                        </div>
                        <IconSelectArrow />
                      </div>
                    </div>
                  ) : null
                }
              >
                <DesktopsSelect>
                  <ul>
                    {tokenList.map((ele) => (
                      <li
                        className="row-start"
                        key={ele.id}
                        onClick={() => {
                          setToken(ele)
                          setChain(undefined)
                          setChainList([])
                          setInput2('')
                        }}
                        aria-hidden
                      >
                        <img src={ele.logo} alt="icon" />
                        <p>{ele.name}</p>
                      </li>
                    ))}
                  </ul>
                </DesktopsSelect>
              </CedeSelect>
              <CedeSelect
                follow
                disabled={!exchange || !token || !chain}
                placeholder="Please select"
                overlay={
                  chain ? (
                    <div className="select">
                      <p className="label">Network</p>
                      <div className="handle row-between">
                        <div className="coin row-start">
                          <img src={chain.logo} alt="icon" />
                          <p>{chain.name}</p>
                        </div>
                        <IconSelectArrow />
                      </div>
                    </div>
                  ) : null
                }
              >
                <DesktopsSelect>
                  <ul>
                    {chainList.map((ele) => (
                      <li
                        className="row-start"
                        key={ele.id}
                        onClick={() => {
                          setChain(ele)
                        }}
                        aria-hidden
                      >
                        <img src={ele.logo} alt="icon" />
                        <p>{ele.name}</p>
                      </li>
                    ))}
                  </ul>
                </DesktopsSelect>
              </CedeSelect>
            </div>
            <p className="balance">
              Balance: {filterThousands(token?.balance ?? 0)} {token?.name}
            </p>
            <div className="input-box">
              <p className="label">Recipient address</p>
              <div className="address row-between">
                <p>{walletClient?.account.address ?? ''}</p>
                <IconGlobalCopy
                  className="hover"
                  onClick={() => {
                    const address = walletClient?.account.address ?? ''
                    clipboard(address)
                    toastSuccess('Success', 'Copy successful')
                  }}
                />
              </div>
            </div>
            <div className="more-input row-between">
              <div className="input-box">
                <p className="label">{token?.name ?? '--'}</p>
                <Input
                  className="input input-only"
                  placeholder="Please input"
                  suffix={
                    <Button
                      className="max"
                      disabled={loading}
                      onClick={() => {
                        if (!token) return
                        const v = filterPrecision(token.balance)
                        setInput2(v)
                      }}
                    >
                      MAX
                    </Button>
                  }
                  value={input2}
                  onChange={(v) => {
                    if (!token) return
                    if (v && verifyValidNumber(v)) return
                    if (Number(v) > Number(token.balance)) return
                    setInput2(v)
                  }}
                />
              </div>
              <div className="input-box">
                <p className="label">USD</p>
                <div className="address row-start">
                  <p>{filterThousands(filterPrice, 2)}</p>
                </div>
              </div>
            </div>
            <p className="minimum">
              Minimum: {filterThousands(chain?.minAmount ?? 0)} {token?.name}
            </p>
            <Button
              className="send"
              disabled={!install || (unlock && (!exchange || !token || !chain || !input2 || !walletClient))}
              loading={loading}
              onClick={() => {
                if (!unlock) {
                  unlockSubmit()
                  return
                }
                handleSubmit()
              }}
            >
              {!unlock ? 'Connect' : 'Send'}
            </Button>
          </div>
        </div>
      </div> */}
      <FooterNew />
    </Wrapper>
  )
}

export default IndexPage
